import * as constant from './constant'
import * as d3 from 'd3'
export const mutations = {
    [constant.FUND_LIST](state, payload) {
        if (payload) {
            state.fundList = payload
        }
    },
    [constant.FUND_AMC](state, payload) {
        if (payload) {
            state.fundAmc = payload
        }
    },
    [constant.FUND_CATEGORIES](state, payload) {
        if (payload) {
            state.fundCategories = payload
        }
    },
    [constant.FUND_TRENDING_LIST](state, payload) {
        if (payload) {
            state.fundTrendingList = payload
        }
    },
    [constant.FUND_NAV](state, payload) {
        if (payload) {
            for (let i = 0; i < payload.length; i++) {
                payload[i].d = d3.timeParse('%Y-%m-%d')(payload[i].nav_date)

                if (state.fundCurrentUnitType == 'price') {
                    payload[i].v = payload[i].value
                } else {
                    payload[i].v = payload[i].amount
                }
            }
            state.fundNav = payload
        }
    },
    [constant.FUND_NAV_VERIFY](state, payload) {
        if (payload) {
            state.fundPeriod = payload
        }
    },
    [constant.FUND_PERIOD](state, payload) {
        if (payload) {
            state.fundCurrentPeriod = payload
        }
    },
    [constant.FUND_UNIT_TYPE](state, payload) {
        if (payload) {
            state.fundCurrentUnitType = payload
        }
    },
    [constant.FUND_PAGINATION](state, payload) {
        if (payload) {
            state.fundPagination = payload
        }
    },
    [constant.FUND_RANKING](state, { payload, period = "1Y", pagination }) {
        if (payload) {
            period = period.toUpperCase()
            state.fundFilter = [] // clear old data
            state.fundPagination = pagination
            payload.forEach(item => {
                state.fundFilter.push({
                    id: item.mstar_id,
                    name: item.thailand_fund_code,
                    data_date: item.nav_date,
                    period: period,
                    percent: item.return_perf,
                    price: item.nav,
                })
            });
        }
    },
    [constant.FUND_FOLLOWING](state, payload) {
        if (payload) {
            state.fundFollowing = payload
        }
    },
}